import { render } from "./ReferralCard.vue?vue&type=template&id=5e04727f&scoped=true"
import script from "./ReferralCard.vue?vue&type=script&lang=js"
export * from "./ReferralCard.vue?vue&type=script&lang=js"

import "./ReferralCard.vue?vue&type=style&index=0&id=5e04727f&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e04727f"]])

export default __exports__